import { Component, OnInit, ViewEncapsulation, Output, Input, EventEmitter } from '@angular/core';

import { RateCardService } from '../../services/rate-card.service';
import { AgreementService } from '../../services';
import { IRateCardInclusivityType } from '../../interfaces/ratecard-inclusivity-type';

export enum RateCardType {
  Driven = 1,
  Transported = 2,
  Recovery = 3,
  Inspection = 4,
  InspectAndCollect = 5,
}

@Component({
  selector: 'rate-card',
  templateUrl: './rate-cards.component.html',
  styleUrls: ['./rate-cards.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class RateCardComponent implements OnInit {
  public isBusy: boolean = false;

  public isLoadedS: boolean = false;
  public isLoadedO: boolean = false;
  public isLoadedU: boolean = false;

  public griddataSD: any[];
  public griddataST: any[];
  public griddataSR: any[];
  public griddataSI: any[];
  public griddataSIC: any[];

  public griddataOD: any[];
  public griddataOT: any[];
  public griddataOR: any[];
  public griddataOI: any[];
  public griddataOIC: any[];

  public griddataUD: any[];
  public griddataUT: any[];
  public griddataUR: any[];
  public griddataUI: any[];
  public griddataUIC: any[];

  //private testCustomerId = 8;
  //private testSupplierId = 9;
  public testCustomerId = 1;
  public testSupplierId = 1;

  inclusivityTypes: IRateCardInclusivityType[] = [];

  constructor(
    private rateCardService: RateCardService,
    private agreementService: AgreementService,
  ) {}

  ngOnInit() {
    this.loadRateCardInclusivityTypes();
    this.load();
  }

  load() {
    this.rateCardService.get(this.testCustomerId, this.testSupplierId, 1).then((result) => {
      var griddataSD = [];
      var griddataST = [];
      var griddataSR = [];
      var griddataSI = [];
      var griddataSIC = [];

      for (var i = 0; i < result.length; i++) {
        switch (result[i].rateCardType) {
          case RateCardType.Driven:
            griddataSD.push(result[i]);
            break;
          case RateCardType.Transported:
            griddataST.push(result[i]);
            break;
          case RateCardType.Recovery:
            griddataSR.push(result[i]);
            break;
          case RateCardType.Inspection:
            griddataSI.push(result[i]);
            break;
          case RateCardType.InspectAndCollect:
            griddataSIC.push(result[i]);
            break;
        }
      }

      this.griddataSD = griddataSD;
      this.griddataST = griddataST;
      this.griddataSR = griddataSR;
      this.griddataSI = griddataSI;
      this.griddataSIC = griddataSIC;
      this.isLoadedS = true;
    });
    this.rateCardService.get(this.testCustomerId, this.testSupplierId, 2).then((result) => {
      var griddataOD = [];
      var griddataOT = [];
      var griddataOR = [];
      var griddataOI = [];
      var griddataOIC = [];

      for (var i = 0; i < result.length; i++) {
        switch (result[i].rateCardType) {
          case RateCardType.Driven:
            griddataOD.push(result[i]);
            break;
          case RateCardType.Transported:
            griddataOT.push(result[i]);
            break;
          case RateCardType.Recovery:
            griddataOR.push(result[i]);
            break;
          case RateCardType.Inspection:
            griddataOI.push(result[i]);
            break;
          case RateCardType.InspectAndCollect:
            griddataOIC.push(result[i]);
            break;
        }
      }

      this.griddataOD = griddataOD;
      this.griddataOT = griddataOT;
      this.griddataOR = griddataOR;
      this.griddataOI = griddataOI;
      this.griddataOIC = griddataOIC;
      this.isLoadedO = true;
    });
    this.rateCardService.get(this.testCustomerId, this.testSupplierId, 3).then((result) => {
      var griddataUD = [];
      var griddataUT = [];
      var griddataUR = [];
      var griddataUI = [];
      var griddataUIC = [];

      for (var i = 0; i < result.length; i++) {
        switch (result[i].rateCardType) {
          case RateCardType.Driven:
            griddataUD.push(result[i]);
            break;
          case RateCardType.Transported:
            griddataUT.push(result[i]);
            break;
          case RateCardType.Recovery:
            griddataUR.push(result[i]);
            break;
          case RateCardType.Inspection:
            griddataUI.push(result[i]);
            break;
          case RateCardType.InspectAndCollect:
            griddataUIC.push(result[i]);
            break;
        }
      }

      this.griddataUD = griddataUD;
      this.griddataUT = griddataUT;
      this.griddataUR = griddataUR;
      this.griddataUI = griddataUI;
      this.griddataUIC = griddataUIC;
      this.isLoadedU = true;
    });
  }

  changeIsServiceOffered(data) {
    if (!data) return;
    console.log(data);
    this.isBusy = true;

    this.rateCardService
      .changeIsServiceOffered(
        this.testCustomerId,
        this.testSupplierId,
        data.serviceId,
        data.isServiceOffered,
      )
      .then((result) => {
        this.updateServiceOffered(this.griddataSD, data.serviceId, data.isServiceOffered);
        this.updateServiceOffered(this.griddataST, data.serviceId, data.isServiceOffered);
        this.updateServiceOffered(this.griddataSR, data.serviceId, data.isServiceOffered);

        this.updateServiceOffered(this.griddataOD, data.serviceId, data.isServiceOffered);
        this.updateServiceOffered(this.griddataOT, data.serviceId, data.isServiceOffered);
        this.updateServiceOffered(this.griddataOR, data.serviceId, data.isServiceOffered);

        this.updateServiceOffered(this.griddataUD, data.serviceId, data.isServiceOffered);
        this.updateServiceOffered(this.griddataUT, data.serviceId, data.isServiceOffered);
        this.updateServiceOffered(this.griddataUR, data.serviceId, data.isServiceOffered);

        this.isBusy = false;
      });
  }

  updateServiceOffered(datas: Array<any>, serviceId: number, isServiceOffered: boolean) {
    for (var i = 0; i < datas.length; i++) {
      if (datas[i].serviceId == serviceId) {
        datas[i].isServiceOffered = isServiceOffered;
      }
    }
  }

  loadRateCardInclusivityTypes(): void {
    this.agreementService.getInclusivityTypes().then((result) => {
      this.inclusivityTypes = result;
    });
  }
}
